import { Breadcrumb, Button, Modal, Table } from 'antd';
// @ts-ignore
import { setAccessToken } from '../../../auth';
// @ts-ignore
import {landinPageUrl,referuspageurl } from '../../../environment';
import DropdownUser from './DropdownUser';
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { encryptNumber, formatTitle } from '@utils/comman';
import { useSelector } from 'react-redux';
import { userLogout } from '../../../actions/user';
import { useDispatch } from 'react-redux';
import { getPendingOutcomeCountAction, getActiveReferralsAction } from '../../../actions/refer';
import moment from 'moment';
import MindbodyConnectModal from "./MindBodyConnectModal";
import "./styles.css"
import { openNotificationWithIcon, verifyMindbodyAction } from '../../../actions/business';

interface HeaderProps {
    pagTitle: string;
    logo?: string;
    actionsCount?: number;
    breadcrumb?: any;
}
const handleToggleBodyClass = () => {
    document.body.classList.toggle('sidebarOpen');
};
const Header: React.FC<HeaderProps> = ({ pagTitle, logo, actionsCount, breadcrumb }) => {
    const location = useLocation()
    const { isLoading } = useSelector((state: any) => state?.General);
    const dispatch = useDispatch();
    let isDashboard = location && location?.pathname && location?.pathname?.split('/')?.[1] === 'dashboard'; 
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pendingCount, setPendingCount] = useState<number>(0);
    const [isActiveReferralsModalVisible, setIsActiveReferralsModalVisible] = useState(false);
    const [activeReferralsData, setActiveReferralsData] = useState([]);
    const [activeReferralsLoading, setActiveReferralsLoading] = useState(false);
    const [open, setOpen] = useState<boolean>(false);
    const [verifyLoading, setVerifyLoading] = useState(false);

    const user = useSelector((state: any) => state?.Auth);
    let userData = user?.user?.data || user?.user?.user;

    const status = userData?.businessDetails?.mindbodyStatus;

    const isNotConnected = status === "not_connected" || !status;
    const isPending = status === "pending";
    const isConnected = status === "connected";

    const renderMindbodyButton = () => {
    if (isConnected) {
        return (
        <Button disabled className="btn-mindbody">
            Mindbody Connected
        </Button>
        );
    }

    if (isPending) {
        return (
        <Button onClick={handleVerify} loading={verifyLoading} className="btn-mindbody">
            Verify Mindbody
        </Button>
        );
    }

    if (isNotConnected && userData?.roleId === 2) {
        return (
        <button
            className="btn-mindbody"
            onClick={() => setOpen(true)}
        >
            Connect Mindbody
        </button>
        );
    }

    return null;
    };

    // Fetch active referrals and count actionable ones
    useEffect(() => {
        if (userData?.roleId === 2) { // Only for referrers (roleId === 2)
            dispatch(getActiveReferralsAction((response: any) => {
                if (response?.status === 200 && response?.data) {
                    // Filter and count only actionable referrals
                    const filteredData = response.data.filter((referral: any) => {
                        const outcome = referral?.outcome?.toLowerCase();
                        const isSelfReferred = referral?.selfSend === true;
                        const isSenderSameAsOwner = referral?.sender?.id === userData?.id;
                        
                        return outcome !== 'fail' && 
                               outcome !== 'false' && 
                               outcome !== 'not_a_fit' && 
                               !isSelfReferred &&
                               !isSenderSameAsOwner;
                    });
                    setPendingCount(filteredData.length);
                }
            }));
        }
    }, [dispatch, userData?.roleId, userData?.id]);
    let breadcrumList = [
        {
            title: 'Home',
            href: '/',
        },
        {
            title: formatTitle(location?.pathname?.split('/')?.join(' ')),
            // href: location?.pathname,
        }
    ]

    const handlePurchase = () => {
        setIsModalOpen(true);
    };

    const handleModalConfirm = () => {
        setIsModalOpen(false);
        console.log('Purchase confirmed!');
        // Add logic to handle the purchase action here
    };

    const handleModalCancel = () => {
        setIsModalOpen(false);
    };

    const confirm: any = (status: any) => {
        console.log("Confirmation....");
        
        dispatch(
            userLogout((resp: any) => {
                if (resp?.success) {
                    setAccessToken('');
                    window.open(`${landinPageUrl}/register?id=${encryptNumber(userData?.id)}`, "_self")
                }
            })
        );
      };

    const handleOk = (status: any) => {

        confirm(status)
      };
    
      const handleCancel = () => {
        setIsModalOpen(false);
      };

    const showActiveReferralsModal = () => {
        setIsActiveReferralsModalVisible(true);
        setActiveReferralsLoading(true);
        dispatch(getActiveReferralsAction((response: any) => {
            if (response?.status === 200 && response?.data) {
                // Filter out referrals with fail status and self-referred ones - only show pending ones
                const filteredData = response.data.filter((referral: any) => {
                    const outcome = referral?.outcome?.toLowerCase();
                    const isSelfReferred = referral?.selfSend === true;
                    const isSenderSameAsOwner = referral?.sender?.id === userData?.id;
                    
                    return outcome !== 'fail' && 
                           outcome !== 'false' && 
                           outcome !== 'not_a_fit' && 
                           !isSelfReferred &&
                           !isSenderSameAsOwner;
                });
                setActiveReferralsData(filteredData);
            }
            setActiveReferralsLoading(false);
        }));
    };

    const handleActiveReferralsCancel = () => {
        setIsActiveReferralsModalVisible(false);
        setActiveReferralsData([]);
    };

    const handleVerify = () => {
        const siteId = userData?.businessDetails?.mindbodySiteId;

        if (!siteId) {
            openNotificationWithIcon("error", "SiteId not found. Please connect again.");
            return;
        }

        setVerifyLoading(true); // START loader

        dispatch(
            verifyMindbodyAction(siteId, (resp: any) => {
            setVerifyLoading(false); // ALWAYS STOP loader
            })
        );
    };
    return (
        <>
            {isDashboard && <div className='isMobileMenu'> <DropdownUser userData={userData} /> </div>}
            {(userData?.roleId ===3 && logo) ? 
                <div className='showLogo'> 
                    <img className='business-logo' src={logo} alt="logo" />
                    <span className="business-lext">Powered by @ReferUs</span>
                </div> : ""}
            <header className="mainHeader">
                <div className="headertitles">
                    <div className="mobilenavigation">
                        <button
                            className="toggleicon"
                            onClick={handleToggleBodyClass}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="60"
                                height="60"
                                viewBox="0 0 60 60"
                                fill="none"
                            >
                                <mask
                                    id="mask0_557_4257"
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="60"
                                    height="60"
                                >
                                    <rect width="60" height="60" />
                                </mask>
                                <g mask="url(#mask0_557_4257)">
                                    <path d="M10 45C9.29167 45 8.69792 44.7604 8.21875 44.2813C7.73958 43.8021 7.5 43.2083 7.5 42.5C7.5 41.7917 7.73958 41.1979 8.21875 40.7188C8.69792 40.2396 9.29167 40 10 40H50C50.7083 40 51.3021 40.2396 51.7812 40.7188C52.2604 41.1979 52.5 41.7917 52.5 42.5C52.5 43.2083 52.2604 43.8021 51.7812 44.2813C51.3021 44.7604 50.7083 45 50 45H10ZM10 32.5C9.29167 32.5 8.69792 32.2604 8.21875 31.7813C7.73958 31.3021 7.5 30.7083 7.5 30C7.5 29.2917 7.73958 28.6979 8.21875 28.2187C8.69792 27.7396 9.29167 27.5 10 27.5H50C50.7083 27.5 51.3021 27.7396 51.7812 28.2187C52.2604 28.6979 52.5 29.2917 52.5 30C52.5 30.7083 52.2604 31.3021 51.7812 31.7813C51.3021 32.2604 50.7083 32.5 50 32.5H10ZM10 20C9.29167 20 8.69792 19.7604 8.21875 19.2812C7.73958 18.8021 7.5 18.2083 7.5 17.5C7.5 16.7917 7.73958 16.1979 8.21875 15.7187C8.69792 15.2396 9.29167 15 10 15H50C50.7083 15 51.3021 15.2396 51.7812 15.7187C52.2604 16.1979 52.5 16.7917 52.5 17.5C52.5 18.2083 52.2604 18.8021 51.7812 19.2812C51.3021 19.7604 50.7083 20 50 20H10Z" />
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div className="pagetitles">{pagTitle}</div>
                </div>
                {(userData?.roleId ===3 && logo) ?
                     <div> 
                        <img className='business-logo' src={logo} alt="logo" />
                        <div className="business-lext">Powered by @ReferUs</div>
                    </div> : ""}

                <div className="secondmenu">
                    {/* <Avatar style={{ backgroundColor: '#87d068' }}  /> */}
                    {/* Ask RU */}
                    {(userData?.roleId === 3 ) && <Button className="btn btn-primary" type='primary' onClick={() => handlePurchase()}>Purchase RU</Button> }
                    {/* <button className='btn p-0' type="button"><img src={AskRU}></img></button> */}
                    {/* <DropdownNotification /> */}
                    
                    {/* Actions Section */}
                    {(actionsCount !== undefined || (userData?.roleId === 2 && pendingCount > 0)) && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#495057',
                            marginRight: '15px'
                        }}>
                            <span>Actions</span>
                            <div 
                                style={{
                                    backgroundColor: '#dc3545',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                }}
                                onClick={showActiveReferralsModal}
                                title="Click to view active referrals"
                            >
                                {actionsCount !== undefined ? actionsCount : pendingCount}
                            </div>
                        </div>
                    )}
                    
                    <div className="integration-buttons">
                    { 
                    userData?.roleId === 2 && 
                        <a
                        href={`${referuspageurl}/api-docs`}
                        className="link-button-integration"
                        target="blank"
                    >
                    API Integration
                    </a>}
               

                    <div className="integration-buttons">
                        {renderMindbodyButton()}
                    </div>
                    </div>
                         
                   <DropdownUser userData={userData} />
                </div>
            </header>
            <div className="breadcrumb">
                {(userData?.roleId !== 1 || breadcrumb) && <Breadcrumb
                    separator=">"
                    items={breadcrumb || breadcrumList}
                />}
            </div>
            {/* Ant Design Modal */}
            <Modal
                title="Buy ReferUs for your business"
                open={isModalOpen}
                onOk={handleModalConfirm}
                onCancel={handleModalCancel}
                footer={[
                    <Button key="back" style={{ height: "30px"}} className='btn btn-outline-primary-md' onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="submit" className='btn btn-primary-md' type="primary" loading={isLoading} onClick={() => handleOk(false)}>
                        {isLoading ? 'Wait we are processing ...' : 'Ok'}
                    </Button>
                ]}
            >
                <p>Are you sure you want to purchase?</p>
                <p>You will be logged out from the current session.</p>
            </Modal>

            {/* Active Referrals Modal */}
            <Modal
                title="Active Referrals"
                open={isActiveReferralsModalVisible}
                onCancel={handleActiveReferralsCancel}
                footer={null}
                width={1200}
            >
                <Table 
                    dataSource={activeReferralsData} 
                    loading={activeReferralsLoading} 
                    columns={[
                        {
                            title: 'Date Referred',
                            dataIndex: 'createdAt',
                            key: 'createdAt',
                            render: (date: any) => moment(date).format('DD/MM/YYYY'),
                            width: 120,
                        },
                        {
                            title: 'First Name',
                            dataIndex: 'firstName',
                            key: 'firstName',
                            width: 100,
                        },
                        {
                            title: 'Last Name',
                            dataIndex: 'lastName',
                            key: 'lastName',
                            width: 100,
                        },
                        {
                            title: 'Contact Number',
                            dataIndex: 'mobileNumber',
                            key: 'mobileNumber',
                            width: 130,
                        },
                        {
                            title: 'Mobile',
                            dataIndex: 'mobile',
                            key: 'mobile',
                            width: 120,
                        },
                        {
                            title: 'Email Address',
                            dataIndex: 'email',
                            key: 'email',
                            width: 200,
                        },
                        {
                            title: 'Company',
                            dataIndex: 'company',
                            key: 'company',
                            width: 150,
                        },
                        {
                            title: 'Category',
                            dataIndex: 'category',
                            key: 'category',
                            width: 120,
                        },
                        {
                            title: 'Contacted Date',
                            dataIndex: 'contactedDate',
                            key: 'contactedDate',
                            render: (date: any) => date ? moment(date).format('DD/MM/YYYY') : '-',
                            width: 130,
                        },
                        {
                            title: 'Outcome',
                            dataIndex: 'outcome',
                            key: 'outcome',
                            render: (outcome: string) => {
                                let color = 'default';
                                let text = 'Pending';
                                
                                switch (outcome?.toLowerCase()) {
                                    case 'pending':
                                        color = 'red';
                                        text = 'Pending';
                                        break;
                                    case 'acknowledged':
                                        color = 'orange';
                                        text = 'Acknowledged';
                                        break;
                                    case 'contacted':
                                        color = 'blue';
                                        text = 'Contacted';
                                        break;
                                    case 'qualified':
                                        color = 'blue';
                                        text = 'Qualified';
                                        break;
                                    case 'not_a_fit':
                                        color = 'gray';
                                        text = 'Not a Fit';
                                        break;
                                    case 'completed':
                                    case 'success':
                                        color = 'green';
                                        text = 'Completed';
                                        break;
                                    default:
                                        color = 'red';
                                        text = 'Pending';
                                }
                                
                                return (
                                    <span style={{
                                        backgroundColor: color,
                                        color: 'white',
                                        padding: '2px 8px',
                                        borderRadius: '4px',
                                        fontSize: '12px'
                                    }}>
                                        {text}
                                    </span>
                                );
                            },
                            width: 100,
                        },
                        {
                            title: 'Paid Offer',
                            dataIndex: 'paidOffer',
                            key: 'paidOffer',
                            render: (amount: any) => amount ? `$${amount}` : '-',
                            width: 100,
                        }
                    ]}
                    pagination={false}
                    scroll={{ x: 1000 }}
                    size="small"
                />
            </Modal>

            <MindbodyConnectModal
             open={open}
             onClose={() => setOpen(false)}
             onSuccess={() => {
               // Refresh user profile / connection status
             }}
           />
        </>
    );
};

export default Header;